export default __webpack_public_path__ + "static/media/folder-open.0c9f4e45.svg";